export class StoreDictionary {
  typeSets: Record<string, any> = {}

  _setTypeSet(type) {
    this.typeSets[type] = {}
  }

  getTypeSet(type) {
    if (!Object.hasOwn(this.typeSets, type)) {
      this._setTypeSet(type)
    }

    return this.typeSets[type]
  }

  getObject(object) {
    if (object?.id) {
      return this.get(object.type, object.id, object)
    }

    return object
  }

  get<T = any>(type, id, defaultValue = null): T | null {
    const typeSet = this.getTypeSet(type)

    const has = Object.hasOwn(typeSet, id)

    if (has) {
      return typeSet[id]
    }

    return defaultValue
  }

  set(type, id, value, force = false) {
    const typeSet = this.getTypeSet(type)

    const has = this.has(type, id)

    if (!has || force) {
      typeSet[id] = value
    }
  }

  has(type, id) {
    const typeSet = this.getTypeSet(type)

    return Object.hasOwn(typeSet, id)
  }

  delete(type, id) {
    const typeSet = this.getTypeSet(type)

    if (Object.hasOwn(typeSet, id)) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete typeSet[id]
    }
  }

  flushType(type) {
    if (Object.hasOwn(this.typeSets, type)) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.typeSets[type]
    }
  }

  flushAll() {
    this.typeSets = {}
  }
}
